export const useDeviceStore = defineStore('device', {
  state: () => ({
    isMobile: false,
    browserTypeId: 15, // UNKNOWN por defecto
    userAgent: ''
  }),
  actions: {
    detectDevice(userAgent: string): void {
      this.userAgent = userAgent
      // Detectar si es un dispositivo móvil
      this.isMobile = /mobile|android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent)
      // Detectar tipo de navegador
      this.browserTypeId = this.detectBrowserType(userAgent)
    },
    
    detectBrowserType(userAgent: string): number {
      if (!userAgent) return 15 // UNKNOWN
      
      // Mapeo de patrones de navegador a IDs según tabla browser_types de la BD
      const browserPatterns = [
        { id: 1, pattern: /Opera/i, name: 'Opera' },
        { id: 2, pattern: /Chrome/i, name: 'Chrome' },
        { id: 3, pattern: /Safari/i, name: 'Safari' },
        { id: 4, pattern: /(Firebird)|(Firefox)/i, name: 'Mozilla Firefox' },
        { id: 5, pattern: /Galeon/i, name: 'Galeon' },
        { id: 6, pattern: /Gecko/i, name: 'Mozilla' },
        { id: 7, pattern: /MyIE/i, name: 'MyIE' },
        { id: 8, pattern: /Lynx/i, name: 'Lynx' },
        { id: 9, pattern: /(Mozilla\/4\.75)|(Netscape6)|(Mozilla\/4\.08)|(Mozilla\/4\.5)|(Mozilla\/4\.6)|(Mozilla\/4\.79)/i, name: 'Netscape' },
        { id: 10, pattern: /Konqueror/i, name: 'Konqueror' },
        { id: 11, pattern: /MSIE 7\.[0-9]+/i, name: 'Internet Explorer 7' },
        { id: 12, pattern: /MSIE 6\.[0-9]+/i, name: 'Internet Explorer 6' },
        { id: 13, pattern: /MSIE 5\.[0-9]+/i, name: 'Internet Explorer 5' },
        { id: 14, pattern: /MSIE 4\.[0-9]+/i, name: 'Internet Explorer 4' },
        { id: 16, pattern: /ByHours\.com\/([0-9]+\.([0-9]+))/i, name: 'ByHours App' }
      ]
      
      // Buscar coincidencia en orden
      for (const browser of browserPatterns) {
        if (browser.pattern.test(userAgent)) {
          return browser.id
        }
      }
      
      return 15 // UNKNOWN si no coincide con ninguno
    }
  },
  getters: {
    getBrowserTypeId: (state) => state.browserTypeId,
    getUserAgent: (state) => state.userAgent,
    getIsMobile: (state) => state.isMobile
  }
})